<template>
    <div style="padding: 1em;">
        <div class="row">
            <div class="col s5" style="padding: 0"><h5>{{$t('inspection.recommendations_list.title')}}</h5></div>
            <div class="col s2" style="margin-top: 15px;">
                <a :href="'/customers/' + this.$route.params.customer_id + '/places/' + this.$route.params.place_id + '/inspections/'+this.inspection_id+'/recommendations.pdf'" class="modal-close waves-effect waves-green btn-flat btn-small green">{{$t('menu.buttons.download_pdf')}}</a>
            </div>
        </div>
        
        {{$t('inspection.recommendations_list.for_protocol')}} {{inspection_id}}
        <template v-if="loaded">
            <br />
            {{$t('inspection.recommendations_list.at_day')}} {{inspection.date | formatDate}}
            <br />
            <br />
            <br />
            <b>{{$t('inspection.recommendations_list.object_name')}}:</b> {{inspection.place_name}} {{inspection.place_address.street}}, {{inspection.place_address.postal_code}} {{inspection.place_address.city}}
            <b>{{$t('inspection.recommendations_list.client_name')}}:</b> {{inspection.customer_name}} {{inspection.customer_address.street}}, {{inspection.customer_address.postal_code}} {{inspection.customer_address.city}}
        </template>
        <preloader v-if="loaded == false" n="7" />
        <table class="table table-striped" v-if="loaded">
            <thead>
                <tr>
                    <th style="padding-left: 0px;">Nr.</th>
                    <th class="smaller" style="white-space: unset !important;">{{$t('recommendations.date')}}</th>
                    <th>{{$t('recommendations.type')}}</th>
                    <th style="max-width: 25vw; min-width: 25vw;">{{$t('recommendations.problem_found')}}</th>
                    <th style="max-width: 25vw; min-width: 25vw;">{{$t('recommendations.problem_cause')}}</th>
                    <th style="max-width: 25vw; min-width: 25vw;">{{$t('recommendations.recommended_solution')}}</th>
                    <th class="smaller" style="white-space: unset !important;">{{$t('recommendations.responsible')}}</th>
                    <th>{{$t('recommendations.status')}}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="recommendation in recommendations">
                    <td>{{recommendation.number}}</td>
                    <td>{{recommendation.date}}</td>
                    <td style="text-transform: uppercase;">{{kinds[recommendation.kind]}}</td>
                    <td>{{recommendation.about}}</td>
                    <td>{{recommendation.cause}}</td>
                    <td>{{recommendation.solution}}</td>
                    <td>{{recommendation.responsible}}</td>
                    <td>{{recommendation.resolved ? $t('recommendations.resolved') : $t('recommendations.pending')}}</td>
                </tr>
            </tbody>
        </table>
        <div class="maincontainer" v-observe-visibility="visibilityChange">
            
        </div>
    </div>
</template>
<script>
import Vue2Filters from 'vue2-filters';
import LineChart from './linechart.vue';
import axios from 'axios';
export default {
    data: function() {
        return {
            order: 'desc',
            orderby: 'date',
            places: [],
            loaded: false,
            saving: false,
            datacollection: [],
            devcats: {},
            visible: false,
            editing: false,
            inspection_id: 0,
            inspection: {},
            kinds: { correction: this.$t('recommendations.correction'), fixing: this.$t('recommendations.repairs'), prevention: this.$t('recommendations.prevention'), emergency: this.$t('recommendations.emergency') },
            selected_kinds: [],
            recommendations: [],
            old_recommendations: []
        }
    },
    props: { customer_id: [String, Number], place_id: [String, Number] },
    async created() {
        await this.fetch_places();
    },
    methods: {
        fetch_places: async function() {
            if (this.place_id != 0 && this.place_id != undefined) {
                var response = await axios.get('/customers/' + this.customer_id + '/places/' + this.place_id + '/recommendations/v2.json')
                this.recommendations = response.data;
                this.loaded = true
            } else {
                this.inspection_id = this.$route.params.inspection_id;
                var inspection_response = await axios.get('/customers/' + this.$route.params.customer_id + '/places/' + this.$route.params.place_id + '/inspections/' + this.$route.params.inspection_id + '.json')
                this.inspection = inspection_response.data;
                var response = await axios.get('/customers/' + this.$route.params.customer_id + '/places/' + this.$route.params.place_id + '/inspections/' + this.$route.params.inspection_id + '/recommendations.json')
                this.recommendations = response.data;
                this.loaded = true
            }

        },
        save_changes: async function() {
            var response = await axios.post('/customers/' + this.customer_id + '/places/' + this.place_id + '/recommendations/multiple_recommendations_update.json', { "recommendations": { "updates": _.keyBy(this.recommendations, 'id') } })
            // this.recommendations = response.data;
            this.editing = false
        },
        edit: function() {
            this.old_recommendations = _.cloneDeep(this.recommendations)
            this.editing = true
        },
        cancelEdit: function() {
            this.recommendations = _.cloneDeep(this.old_recommendations)
            this.editing = false
        },
        unresolve: function(reco) {
            if (this.editing == false) {
                this.edit()
            }
            reco.status = 'unresolved'
        },
        resolve: function(reco) {
            if (this.editing == false) {
                this.edit()
            }
            reco.status = 'resolved'
        },
        collapse: function(customer) {
            customer.collapsed = !(customer.collapsed);
            this.$forceUpdate();
        },

        set_order: function(order) {
            if (this.orderby == order) {
                if (this.order == 'desc') {
                    this.order = 'asc'
                } else if (this.order == 'asc') {
                    this.order = 'desc'
                }

            } else {
                this.orderby = order;
            }
        },
        visibilityChange(evt, hidden) {
            this.visible = evt;
        },
        name_kinds: function(kind) {
            var out = ""
            out += { "correction": this.$t('recommendations.correction'), "fixing": this.$t('recommendations.repairs'), "prevention": this.$t('recommendations.prevention'), "emergency": this.$t('recommendations.emergency') } [kind] + " "

            return out;
        }
    },
    computed: {
        listItems() {
            var that = this;
            return _.filter(
                _.orderBy(this.recommendations, this.orderby, this.order),
                function(item) {
                    return (_.intersection(that.selected_kinds, item.types).length > 0 || that.selected_kinds.length == 0)
                }
            );
        },
        lastInspection: function() {
            var inps = _.last(_.orderBy(this.recommendations, 'date'));
            if (_.isUndefined(inps) == false)
                return inps.date;
            return "-"
        },
    },
    mixins: [Vue2Filters.mixin],
}
</script>
<style scoped>
.maincontainer {
    text-align: left;
}

p {
    font-size: 2em;
    text-align: center;
}

thead th {
    font-weight: 300;
}

thead .input-field {
    margin-top: unset;
    margin-bottom: unset;
}

select {
    display: block;
    background-color: white !important;
    border-radius: 4px !important;
    border-width: 1px !important;
    border-style: solid !important;
    border-color: rgb(140, 140, 140) !important;
    padding-left: 5px !important;
    height: 35px !important;
}

.btn-large /deep/ {
    border-radius: 8px;
    background-color: white;
    color: black;
    border-color: #00CC66;
    border-width: 1px;
    border-style: solid;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/deep/ .emptygreen {
    background-color: #FFF !important;
    border-color: #00CC66;
    border-width: 1px;
    border-style: solid;
}

.col .row .col div {
    display: flex;
    max-height: 60px;
}

.emptyred {
    border-color: #c22026;
}
</style>